import { API_ROOT } from '../../../config';
import { ssFetchJSON } from '../../../modules/ssFetch';

export function cancelAppointmentById(
  providerId: number,
  appointmentId: number,
  cancelAll: boolean = false,
): Promise<unknown> {
  const url = new URL(`/api/v2.1/providers/${providerId}/appointments/${appointmentId}/cancellations`, API_ROOT);
  const body = cancelAll ? { cancel_all: !!cancelAll } : undefined;
  return ssFetchJSON(url.toString(), {
    method: 'POST',
    body,
  });
}
